import { defineMessages } from 'react-intl';

export default defineMessages({
    auto: {
        id: 'ml.common.util.MLPolicyTypeUtil.Auto',
        defaultMessage: 'Auto'
    },
    condo: {
        id: 'ml.common.util.MLPolicyTypeUtil.Condo',
        defaultMessage: 'Condo'
    },
    home: {
        id: 'ml.common.util.MLPolicyTypeUtil.Home',
        defaultMessage: 'Home'
    },
    homeowners: {
        id: 'ml.common.util.MLPolicyTypeUtil.Homeowners',
        defaultMessage: 'Homeowners'
    },
    landlordCondo: {
        id: 'ml.common.util.MLPolicyTypeUtil.Landlord Condo',
        defaultMessage: 'Landlord Condo'
    },
    landlordHome: {
        id: 'ml.common.util.MLPolicyTypeUtil.Landlord Home',
        defaultMessage: 'Landlord Home'
    },
    renters: {
        id: 'ml.common.util.MLPolicyTypeUtil.Renters',
        defaultMessage: 'Renters'
    },
    umbrella: {
        id: 'ml.common.util.MLPolicyTypeUtil.Umbrella',
        defaultMessage: 'Umbrella'
    }

});
